module.exports = __webpack_public_path__ + "img/pathGeoloc.e45a4322.svg";